module.exports = __webpack_public_path__ + "fontawesome-webfont.af7ae505a9eed503f8b8.woff2";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/font-awesome/fonts/fontawesome-webfont.woff2?v=4.7.0
// module id = ../../../../../src/scss/icons/font-awesome/fonts/fontawesome-webfont.woff2?v=4.7.0
// module chunks = styles